import React from "react";
import { useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { experienceAnalysis } from "../../../../../store/slices/ai";
import { Template } from "../Template";

export const GatheringDataStep = () => {
  const analysis = useSelector(experienceAnalysis);
  return (
    <Template
      leftNode={
        <Grid
          container
          item
          direction={"row"}
          columnSpacing={1}
          alignItems={"center"}
          sx={{ height: "100%" }}
        >
          <Grid item>
            <IgTypography sx={{ fontWeight: 600, fontSize: "18px" }}>
              Gathering Data...
              {analysis.dataProgress
                ? ` ${analysis.dataProgress.toFixed(0)}%`
                : ``}
            </IgTypography>
          </Grid>
        </Grid>
      }
    />
  );
};
